import { PayScheduleLocations } from './pay-schedule.model';

export class UserOrgs {
  id: number;
  userId: number;
  orgId: number;
  roleId = '';
  isPrimary = true;
  orgName = '';
  roleName = '';
}

export class OrgLocation {
  id: number;
  code: string;
  organizationId: number;
  name: string;
  description: string;
  legacyRowId: number;
  legacyOrganizationId: number;
  organization: Organization;
  payScheduleLocation: PayScheduleLocations[];
}

export class Organization {
  id: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  zip4: string;
  isActive: boolean;
  legacyRowId: number;
  country: string;
  emailDomain: string;
  location: OrgLocation;
}
